import DataSourceUsageDto from "../datasourcemodule/DataSourceUsageDto";

class CustomerAgentUsageDto {
    public DataSourceId: number;
    public DataSourceName: string;
    public DataSourceType: string;
    public DataSourceUsages: DataSourceUsageDto[];

    constructor(
        dataSourceId: number,
        dataSourceName: string,
        dataSourceType: string,
        dataSourceUsages: DataSourceUsageDto[]
    ) {
        this.DataSourceId = dataSourceId;
        this.DataSourceName = dataSourceName;
        this.DataSourceType = dataSourceType;
        this.DataSourceUsages = dataSourceUsages;
    }
}

export default CustomerAgentUsageDto;
